(() => {
  function init() {
    const root = document.querySelector('[data-care-page="fine"]');
    if (!root || root.dataset.careReady) return;
    root.dataset.careReady = 'true';
    const get = id => root.querySelector('#' + id);
    const all = s => Array.from(root.querySelectorAll(s));
    const fields = all('[data-note]');
    const results = get('results');
    const close = button => {
      button.setAttribute('aria-expanded', 'false');
      get(button.getAttribute('aria-controls')).hidden = true;
      button.querySelector('span').textContent = '⌄';
    };
    all('.r4-trigger').forEach(button => button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      get(button.getAttribute('aria-controls')).hidden = !open;
      button.querySelector('span').textContent = open ? '⌃' : '⌄';
    }));
    fields.forEach(field => field.addEventListener('change', () => {
      const control = field.closest('.r4-control');
      const names = Array.from(control.querySelectorAll('input:checked')).map(x => x.value);
      const summary = control.querySelector('.r4-selected');
      summary.textContent = names.join(' · ');
      summary.hidden = !names.length;
    }));
    get('read-notes').addEventListener('click', event => {
      event.preventDefault();
      const selected = fields.filter(x => x.checked);
      const ids = new Set(selected.map(x => x.dataset.note));
      results.hidden = false;
      get('selected-context').hidden = !selected.length;
      get('notes').hidden = !selected.length;
      get('empty-state').hidden = !!selected.length;
      get('unlisted-context').hidden = !selected.length;
      get('selected-summary').textContent = root.dataset.selectedPrefix + selected.map(x => x.value).join(' · ');
      all('.r4-note').forEach(note => { note.hidden = !ids.has(note.id); });
      get('unknown-context').hidden = !selected.length || selected.some(x => x.dataset.category === 'Gemstone');
      all('.r4-trigger').forEach(close);
      const target = get(selected.length ? 'selected-context' : 'empty-state');
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll:true});
      target.scrollIntoView({block:'start'});
    });
    all('.r4-return').forEach(link => link.addEventListener('click', event => {
      event.preventDefault(); results.hidden = true; get('unlisted-context').hidden = false;
      all('.r4-trigger')[0].focus({preventScroll:true}); get('care-reference').scrollIntoView({block:'start'});
    }));
    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const control = event.target.closest('.r4-control');
      if (!control) return;
      const button = control.querySelector('.r4-trigger'); close(button); button.focus();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
